<script>
  import { onMount } from 'svelte';
  import { storedEditorContent, prefilledReportContent } from "store";
  
  export let editorContent;
  let elm;
  onMount(() => {
    if ($prefilledReportContent !== null) {
      editorContent = $prefilledReportContent;
      prefilledReportContent.set(null);
      storedEditorContent.set(editorContent);  
    } else {
      editorContent = $storedEditorContent;
    }
    elm.focus();
	});

  function handleEdit(e) {
    storedEditorContent.set(editorContent);
  };

  function handleEditorClick(e) {
    if (e.srcElement.className === "varspan") {
      let range, selection;
      if (window.getSelection && document.createRange) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(e.srcElement);
          selection.removeAllRanges();
          selection.addRange(range);
      } else if (document.selection && document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(e.srcElement);
          range.select();
      }
    }
  };

  function handlePaste(e) {
    e.preventDefault();
    let mytext = (e.originalEvent || e).clipboardData.getData('text/plain');
    document.execCommand("insertText", false, mytext);
  };

  // function copyText(e) {
  //   elm.focus();
  //   document.execCommand("selectAll", false, "");
  //   document.execCommand("copy", false, "");
  // };
</script>

<main>
  <div id="toolkiteditor" contenteditable="true" bind:innerHTML={editorContent} on:paste={handlePaste} on:click={handleEditorClick} on:input={handleEdit} bind:this={elm}></div>
</main>

<style>
  [contenteditable] {
    min-height: 400px;
    padding: 0.5em;
    border: 1px solid #eee;
    border-radius: 4px;
    font-family: "Courier";
    font-size: 14px;
	}
</style>